import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useForm, useWatch } from 'react-hook-form';
import { View, Text, FlatList, Button, TextInput, StyleSheet, useWindowDimensions } from 'react-native';
import { ActivityIndicator, Card } from 'react-native-paper';
import CustomLabel from '../../../components/CustomLabel/CustomLabel';
import CustomInput from '../../../components/CustomInput';
import { SafeAreaView } from 'react-native-safe-area-context';
import CustomDropDown from '../../../components/CustomDropDown/CustomDropdown';
import CustomCalendar from '../../../components/CustomCalendar/CustomCalendar';
import CustomButton from '../../../components/CustomButton';
import { useHRAdminEmployees } from '../../../hooks/useHRAdminEmployees';
import Ionicons from "@react-native-vector-icons/ionicons/static";
import CustomControlledInput from '../../../components/ControlledComponents/CustomControlledInput';
import CustomControlledDropdown from '../../../components/ControlledComponents/CustomControlledDropdown';
import { useTableHelper } from '../../../hooks/useTableHelper';

const FlatListViewFamily = React.memo(({ item, styles, t, control, familyDropdowns, convertDate, handleDelete,
    modal, setValue, index, width
}) => {
    const [showAdditionalInformation, setShowAdditionalInformation] = useState(false);
    const [showCalendar, setShowCalendar] = useState(false);
    const [selectedData, setSelectedData] = useState([]);

    //#region UseEffect
    useEffect(() => {
        const dateToSet = selectedData?.startDate ? convertDate(selectedData.startDate) : '';
        setValue(`${item.ui}.dob.startDate`, dateToSet);
    }, [selectedData])

    useEffect(() => {
        let dob = item?.dob;
        if (dob !== '' && dob !== null) {
            setSelectedData({ startDate: dob })
        }
        else setSelectedData([]);
    }, [])
    //#endregion

    //#region Helper Functions
    const onShowAdditionalLocationInfoPress = () => {
        setShowAdditionalInformation(!showAdditionalInformation)
    }

    const onShowCalendarPress = (key) => {
        setShowCalendar(!showCalendar)
    }
    //#endregion

    return (
        <SafeAreaView>
            <SafeAreaView style={styles.row}>
                <View
                    style={[styles.item]}>
                    <SafeAreaView>
                        <CustomLabel value={t(`common:name`)} type='SUBTITLENOFLEX' />
                        <CustomControlledInput
                            name={`${item.ui}.name`}
                            control={control}
                            editable={true}
                            type='MAININPUT'
                            rules={{
                                required: t('common:nameReqMess'),
                                pattern: {
                                    value: /^[A-Za-z\s-]+$/,
                                    message: t('common:nameAlphabetOnlyMess')
                                }
                            }}
                        />
                    </SafeAreaView>
                </View>
                <View
                    style={[styles.item]}>
                    <SafeAreaView>
                        <CustomLabel value={t(`common:relType`)} type='SUBTITLENOFLEX' />
                        <CustomControlledDropdown
                            multipleSelect={true}
                            control={control}
                            name={`${item.ui}.relType`}
                            type="EDIT_EMPLOYEE"
                            options={familyDropdowns?.relType?.options}
                            rules={{
                                required: t(`common:relTypeReqMess`),
                            }}
                        />
                    </SafeAreaView>
                </View>
                <View
                    style={[styles.item]}>
                    <SafeAreaView>
                        <CustomLabel value={t(`common:gender`)} type='SUBTITLENOFLEX' />
                        <CustomControlledDropdown
                            multipleSelect={true}
                            control={control}
                            name={`${item.ui}.gender`}
                            type="EDIT_EMPLOYEE"
                            options={familyDropdowns?.sex?.options}
                        />
                    </SafeAreaView>
                </View>


                <SafeAreaView style={[{ flexDirection: width < 1300 ? 'column' : 'row' }]}>
                    <CustomButton
                        iconName={!showAdditionalInformation ? 'chevron-forward-outline' : 'chevron-down-outline'}
                        onPress={() => {
                            onShowAdditionalLocationInfoPress()
                        }}
                        text={t('common:additionalInfos')}
                        show='PART'
                        type='PART'
                        textTop='0'
                        sz={30} />
                    <CustomButton
                        iconName={"trash-outline"}
                        onPress={() => {
                            handleDelete(item, index, 'ui', modal)
                        }}
                        show='PART'
                        type='PART'
                        textTop='0'
                        sz={30} />
                </SafeAreaView>
                <View style={styles.verticalLine} />
            </SafeAreaView>
            {showAdditionalInformation &&
                <SafeAreaView>
                    <SafeAreaView style={styles.row}>
                        <View
                            style={[styles.item]}>
                            <SafeAreaView>
                                <CustomLabel value={t(`common:occupation`)} type='SUBTITLENOFLEX' />
                                <CustomControlledDropdown
                                    multipleSelect={true}
                                    control={control}
                                    name={`${item.ui}.occupation`}
                                    type="EDIT_EMPLOYEE"
                                    options={familyDropdowns?.occupation?.options}
                                />
                            </SafeAreaView>
                        </View>

                        <View
                            style={[styles.item]}>
                            <SafeAreaView>
                                <CustomLabel value={t(`common:underSponsorship`)} type='SUBTITLENOFLEX' />
                                <CustomControlledDropdown
                                    multipleSelect={true}
                                    control={control}
                                    name={`${item.ui}.underSponsorship`}
                                    type="EDIT_EMPLOYEE"
                                    options={familyDropdowns?.underSponsorship?.options}
                                    defValue={"NO"}
                                />
                            </SafeAreaView>
                        </View>
                    </SafeAreaView>
                    <SafeAreaView style={styles.row}>
                        <SafeAreaView style={styles.item}>
                            <CustomLabel value="Comments" type='SUBTITLENOFLEX' />
                            <CustomControlledInput
                                name={`${item.ui}.comments`}
                                control={control}
                                editable={true}
                                type='MAININPUT'
                            />
                        </SafeAreaView>
                        <View
                            style={[styles.item]}>
                            <CustomLabel value={t(`common:dateOfBirth`)} type='SUBTITLENOFLEX' />
                            <SafeAreaView style={styles.row}>
                                <CustomControlledInput
                                    name={`${item.ui}.dob.startDate`}
                                    control={control}
                                    editable={false}
                                    type='MAININPUT'
                                />
                                <Ionicons
                                    name={showCalendar ? "calendar" : "calendar-outline"}
                                    style={styles.icons}
                                    onPress={() => onShowCalendarPress(true)}
                                />
                            </SafeAreaView>
                        </View>
                    </SafeAreaView>
                </SafeAreaView>
            }
            {showCalendar &&
                <SafeAreaView style={styles.secondLine}>
                    {/* calendar view */}
                    <View style={{
                        justifyContent: 'center',
                        alignContent: 'center',
                        borderRadius: 10,
                        borderWidth: 0,
                        borderColor: colors.border_card,
                    }}>
                        <CustomCalendar
                            calendarType={'RangePicker'}
                            setRange={setSelectedData}
                            range={selectedData}
                            allowSingleDate={true}
                            startingYear={1950}
                        />
                    </View>
                </SafeAreaView>
            }
        </SafeAreaView>
    )
})


const HRAdminFamilyDetails = ({ props }) => {
    //#region Variables
    const { familyDropdowns, selectedEmployee, convertDate, flatlistEditPress, styles, common,
        modal, t, modalVisible, setModalVisible, ActivityIndicator, colors
    } = props;
    const { width, height } = useWindowDimensions();
    const [changes, setChanges] = useState([]);
    const { getFamilyDetails, updateFamilyDetails, insertFamilyDetails, deleteFamilyDetails } = useHRAdminEmployees();
    const [familyDetails, setFamilyDetails] = useState([]);
    const [insertData, setInsertData] = useState([]);
    const [deletedItems, setDeletedItems] = useState([]);
    const [originalFamilyDetails, setOriginalFamilyDetails] = useState([]);
    const [duplicates, setDuplicates] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const { handleCancelChanges, rowAdd, rowDelete } = useTableHelper();
    const { control, handleSubmit, formState: { errors }, setValue, unregister, register } = useForm();
    const [state, setState] = useState(null);
    const [showState, setShowState] = useState(false);
    const ref = useRef(null);
    //#endregion

    //#region UseEffects
    useEffect(() => {
        setIsLoading(true);
        getFamilyDetails(selectedEmployee?.employeeID).then((res) => {
            let family = res?.data;
            if (Array.isArray(family)) {
                setFamilyDetails(family);
                setOriginalFamilyDetails(family);
                family.forEach((item, index) => {
                    item['dob'] = item?.dob?.split('T')[0];
                    Object.keys(item).forEach(key => {
                        setValue(`${item.ui}.${key}`, item[key]);
                    });
                });
            } else {
                console.error("Family details are not in array format.");
            }
            setIsLoading(false);
        }).catch((error) => {
            console.error("Error fetching family details:", error);
            setIsLoading(false);
        });
    }, []);

    useEffect(() => {
        if (state) {
            setShowState(true);
            const timer = setTimeout(() => {
                setShowState(false);
            }, 10000);
            return () => {
                clearTimeout(timer)
                setState(null);
            };
        }
    }, [state]);

    useEffect(() => {
        if (familyDetails.length <= 0) return;
        let item = familyDetails[0];
        Object.keys(item).forEach(key => {
            if (key === 'dob')
                register(`${item.ui}.${key}.startDate`);
            else
                register(`${item.ui}.${key}`);
        });
    }, [familyDetails, setValue]);
    //#endregion

    //#region Getters
    const getUpdatedData = (data) => {
        let remainingObjects = [];
        Object.keys(data).forEach((key, index) => {
            data[key].dob = data[key].dob.startDate ?? null;
            if (!insertData.includes(key) && !deletedItems.includes(key)) {
                remainingObjects.push(data[key]);
            }
        });
        return remainingObjects;
    }

    const getDeletedData = () => {
        insertData.forEach((ui, indexInsert) => {
            deletedItems.forEach((delUi, indexDelete) => {
                if (ui === delUi) {
                    insertData.splice(indexInsert, 1);
                    deletedItems.splice(indexDelete, 1);
                }
            });
        });
    }
    //#endregion

    //#region Submit
    const onSubmit = data => {
        let updates = getUpdatedData(data);
        getDeletedData();
        const inserts = findObjects(data, insertData);
        return submitData(inserts, updates, deletedItems)
    };

    const submitData = async (insertData, updateData, deleteData) => {
        let newPromises = [];
        let deleteSucc = true;
        let updateSucc = true;
        let insertSucc = true;
        let employeeid = selectedEmployee?.employeeID;

        setState('saving');
        if (insertData.length > 0)
            newPromises.push(
                insertFamilyDetails(insertData, employeeid).then((res) => {
                    if (res?.status === 200) insertSucc = true;
                }).catch(() => { })
            )
        if (deleteData.length > 0)
            newPromises.push(
                deleteFamilyDetails(deleteData, employeeid).then((res) => {
                    if (res?.status === 200) deleteSucc = true;
                }).catch(() => { })
            )
        if (updateData.length > 0)
            newPromises.push(
                updateFamilyDetails(updateData, employeeid).then((res) => {
                    if (res?.status === 200)
                        updateSucc = true;
                }).catch(() => { })
            )
        try {
            await Promise.all(newPromises).then(() => {
                if (!updateSucc) {
                    if (!deleteSucc) {
                        setState('deleteFailed');
                    }
                    else
                        setState('issueMessage');
                }
                else if (deleteSucc && updateSucc && insertSucc) {
                    setState('allOperationsSuccMess');
                }
            });
        } catch (error) {
            console.log(error)
        }
    }
    //#endregion

    //#region Helpers
    const findObjects = (mainObject, arr) => {
        return arr.map(ui => {
            const innerObject = mainObject[ui];
            if (innerObject) {
                return {
                    ...innerObject,
                    ui,
                    employeeID: innerObject.employeeID ?? selectedEmployee?.employeeID,
                };
            }
            return null;
        }).filter(item => item !== null);
    };
    //#endregion

    //#region Handlers
    const handleAddPress = () => {
        let exceptions = ['ui', 'employeeid', 'name', 'relType', 'gender', 'dob', 'occupation', 'comments', 'underSponsorship', 'userid', 'doc'];
        let response = rowAdd(familyDetails, setFamilyDetails, exceptions, [], ref, t, [], [], changes, setChanges, insertData, setInsertData, id = 'ui', isModal = true);
        if (response?.message) setState(response?.message)
    };

    const handleRemovePress = () => {
        handleCancelChanges(setFamilyDetails, originalFamilyDetails, setDeletedItems, setChanges, setDuplicates);
    };

    const handleDelete = (item, index, attribute, modal) => {
        rowDelete(item, index, attribute, changes, setChanges, familyDetails, setFamilyDetails, setDeletedItems, ref);
        unregister(`items.${item.ui}`);
    }
    //#endregion

    //#region Modal
    const closeModal = () => {
        setModalVisible(!modalVisible);
    }
    //#endregion

    //#region Renderer
    const renderItem = useCallback(({ item, index }) => {
        return (
            <Card
                style={[common.cardstyle]} >
                <Card.Content>
                    <FlatListViewFamily
                        styles={styles}
                        control={control}
                        item={item}
                        index={index}
                        familyDropdowns={familyDropdowns}
                        handleDelete={handleDelete}
                        modal={modal}
                        setValue={setValue}
                        width={width}
                        convertDate={convertDate}
                        t={t}
                    />
                </Card.Content>
            </Card>
        )
    }, [familyDetails]);
    //#endregion

    //#region Loading
    if (isLoading)
        return (
            <View style={styles.loader}>
                <ActivityIndicator animating={true} color={colors.blue} />
            </View>
        )
    //#endregion

    return (
        <SafeAreaView style={styles.mainView}>
            <View style={styles.iconRow}>
                {modal?.allowsAddDelete ? (
                    <View style={styles.leftIcons}>
                        <Ionicons
                            name={"add-circle-outline"}
                            style={styles.icon}
                            onPress={handleAddPress}
                        />
                        <Ionicons
                            name={"remove-circle-outline"}
                            style={styles.icon}
                            onPress={handleRemovePress}
                        />
                    </View>
                ) : (
                    <View style={styles.leftIcons}></View>
                )}
                <View style={[styles.rightIcon, { flexDirection: 'row' }]}>
                    {state && showState && <CustomLabel
                        value={`${t('common:state')}: ${t(`common:${state}`)}`}
                        type='EDIT_EMPLOYEE_STATE'
                    />}
                    <Ionicons
                        name={"close-circle-outline"}
                        style={styles.icon}
                        onPress={closeModal}
                    />
                </View>
            </View>
            <FlatList
                style={{ height: height / 3, flexGrow: 0 }}
                data={familyDetails}
                keyExtractor={(item) => `${item?.ui}`}
                renderItem={renderItem}
                scrollEnabled={true}
                refreshing={isLoading}
                ref={ref}
                initialNumToRender={10}
                ListHeaderComponent={
                    <CustomLabel
                        value={`${selectedEmployee?.name}'s ${t(`common:${modal?.title}`)}`}
                        type='SUBTITLE'
                    />
                }
                ListEmptyComponent={
                    isLoading ? (
                        <ActivityIndicator animating={true} color={colors.blue} />
                    ) : (
                        <CustomLabel
                            value={t("common:familyDetailsLoadingPreview")}
                            type="NO_BRANCHES"
                        />
                    )
                }
            />
            <View style={[styles.functionalityButtons]}>
                <CustomButton
                    text={t('common:saveChanges')}
                    onPress={handleSubmit(onSubmit)}
                    type='BUTTON_SAVE'
                    isGradient={true}
                    textTop='0'
                    sz={15}
                />
            </View>
        </SafeAreaView>
    );
};

export default HRAdminFamilyDetails;